import { AgeGroups, ROUTE_IDS } from '@lx/quote-tool/shared/types';

export const INITIAL_ROUTE_PER_AGE_GROUP: Record<AgeGroups, ROUTE_IDS> = {
  ['adult']: ROUTE_IDS.ADULT_BASE,
  ['junior']: ROUTE_IDS.JUNIOR_BASE,
  ['online']: ROUTE_IDS.ONLINE_BASE,
};
